
export const eventsName = {
  roka: "Roka",
  engagement: "Engagement",
  haldi: "Haldi",
  mehndi: "Mehndi",
  sangeet: "Sangeet",
  cocktail: "Cocktail",
  wedding: "Wedding",
  musicBash: "Music Bash",
  reception: "Reception",
  custom: "Custom",
};

export const eventTheme = {
  traditional: "Traditional",
  floral: "Floral",
  pastel: "Pastel",
  glamNight: "Glam Night",
  royal: "Royal",
  contemporary: "Contemporary",
  vibrant: "Vibrant",
  sunshine: "Sunshine",
  colorSplash: "Color Splash",
  folk: "Folk",
  garden: "Garden",
  glamGlitz: "Glam & Glitz",
  bollywood: "Bollywood",
  starryNight: "Starry Night",
  chic: "Chic",
  western: "Western",
  luxeEvening: "Luxury Evening",
  heritage: "Heritage",
  partyVibes: "Party Vibes",
  fusion: "Fusion",
  dJNight: "DJ Night",
  elegant: "Elegant",
  regal: "Regal",
  modernLuxe: "Modern Luxury",
};

export const dressCode = {
  ethnicWear: "Ethnic Wear",
  semiFormal: "Semi-Formal",
  indianFormal: "Indian Formal",
  indoWestern: "Indo-Western",
  suitsDresses: "Suits/Dresses",
  simpleEthnic: "Simple Ethnic",
  lightKurta: "Light Kurta/Saree",
  traditional: "Traditional",
  sparklingWestern: "Sparkling Western (Tuxedos, Gowns)",
  indoWesternSherwani: "Indo Western (Sherwani, Lehenga)",
  sparklingWesternSuitsDress: "Sparkling Western (Tuxedos/Suits, Dresses/Gowns)",
  ethinicFormal: "Ethnic Formals (Sherwani/Bandhgala, Lehenga/Saree)",
  ethinicFormalBandGala: "Ethnic Formals (Sherwani/Bandhgala, Lehenga/Saree)",
  trendyCasuals: "Trendy Casuals",
  funOutfits: "Fun Outfits",
  suitsGrowns: "Suits, Gowns/Sarees",
};

export const dressColor = {
  pastelShades: "Pastel Shades (Peach, Mint, Lavender)",
  goldOffWhite: "Gold, Off-White",
  silver: "Silver",
  navyBlue: "Navy Blue",
  emerald: "Emerald",
  green: "Green",
  wine: "Wine",
  yellow: "Yellow",
  orange: "Orange",
  white: "White",
  pink: "Pink",
  turquoise: "Turquoise",
  goldBlack: "Gold, Black",
  maroon: "Maroon",
  metellicShades: "Metallic Shades",
  black: "Black",
  burgundy: "Burgundy",
  navySilver: "Navy, Silver",
  red: "Red",
  ivory: "Ivory",
  neon: "Neon",
  metallic: "Metallic",
  pastels: "Pastels",
  navyGrey: "Navy, Grey",
  gold: "Gold",
  champagne: "Champagne",
};
// export const EVENT_NAME = () => [
//   {
//     id: '0',
//     name: {eventsName.roka},
//     tagline: i18n.t('eventTagline.roka'),
//     Icon: SVGS.roka,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.traditional')},
//       {id: '1', name: i18n.t('eventTheme.floral')},
//       {id: '2', name: i18n.t('eventTheme.pastel')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.ethnicWear')},
//       {id: '1', name: i18n.t('dressCode.semiFormal')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.pastelShades')},
//       {id: '1', name: i18n.t('dressColor.goldOffWhite')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '1',
//     name: i18n.t('eventsName.engagement'),
//     tagline: i18n.t('eventTagline.engagement'),
//     Icon: SVGS.engagement,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.glamNight')},
//       {id: '1', name: i18n.t('eventTheme.royal')},
//       {id: '2', name: i18n.t('eventTheme.contemporary')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.indianFormal')},
//       {id: '1', name: i18n.t('dressCode.indoWestern')},
//       {id: '2', name: i18n.t('dressCode.suitsDresses')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.silver')},
//       {id: '1', name: i18n.t('dressColor.navyBlue')},
//       {id: '2', name: i18n.t('dressColor.emerald')},
//       {id: '3', name: i18n.t('dressColor.green')},
//       {id: '4', name: i18n.t('dressColor.wine')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '2',
//     name: i18n.t('eventsName.haldi'),
//     tagline: i18n.t('eventTagline.haldi'),
//     Icon: SVGS.haldiOne,
//     IconTwo: SVGS.haldiTwo,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.vibrant')},
//       {id: '1', name: i18n.t('eventTheme.sunshine')},
//       {id: '2', name: i18n.t('eventTheme.floral')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.simpleEthnic')},
//       {id: '1', name: i18n.t('dressCode.lightKurta')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.yellow')},
//       {id: '1', name: i18n.t('dressColor.orange')},
//       {id: '2', name: i18n.t('dressColor.white')},
//       {id: '3', name: i18n.t('dressColor.green')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '3',
//     name: i18n.t('eventsName.mehndi'),
//     tagline: i18n.t('eventTagline.mehndi'),
//     Icon: SVGS.mehandi,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.colorSplash')},
//       {id: '1', name: i18n.t('eventTheme.folk')},
//       {id: '2', name: i18n.t('eventTheme.garden')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.traditional')},
//       {id: '1', name: i18n.t('dressCode.indoWestern')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.green')},
//       {id: '1', name: i18n.t('dressColor.pink')},
//       {id: '2', name: i18n.t('dressColor.yellow')},
//       {id: '3', name: i18n.t('dressColor.turquoise')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '4',
//     name: i18n.t('eventsName.sangeet'),
//     tagline: i18n.t('eventTagline.sangeet'),
//     Icon: SVGS.sangeet,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.glamGlitz')},
//       {id: '1', name: i18n.t('eventTheme.bollywood')},
//       {id: '2', name: i18n.t('eventTheme.starryNight')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.sparklingWestern')},
//       {id: '1', name: i18n.t('dressCode.indoWesternSherwani')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.goldBlack')},
//       {id: '1', name: i18n.t('dressColor.maroon')},
//       {id: '2', name: i18n.t('dressColor.metellicShades')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '5',
//     name: i18n.t('eventsName.cocktail'),
//     tagline: i18n.t('eventTagline.cocktail'),
//     Icon: SVGS.cockTail,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.chic')},
//       {id: '1', name: i18n.t('eventTheme.western')},
//       {id: '2', name: i18n.t('eventTheme.luxeEvening')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.sparklingWesternSuitsDress')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.black')},
//       {id: '1', name: i18n.t('dressColor.burgundy')},
//       {id: '2', name: i18n.t('dressColor.navySilver')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '6',
//     name: i18n.t('eventsName.wedding'),
//     tagline: i18n.t('eventTagline.wedding'),
//     Icon: SVGS.wedding,
//     IconTwo: SVGS.wedding,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.royal')},
//       {id: '1', name: i18n.t('eventTheme.heritage')},
//       {id: '2', name: i18n.t('eventTheme.traditional')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.ethinicFormalBandGala')},
//       {id: '1', name: i18n.t('dressCode.indoWestern')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.red')},
//       {id: '1', name: i18n.t('dressColor.gold')},
//       {id: '2', name: i18n.t('dressColor.ivory')},
//       {id: '3', name: i18n.t('dressColor.maroon')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '7',
//     name: i18n.t('eventsName.musicBash'),
//     tagline: i18n.t('eventTagline.musicBash'),
//     Icon: SVGS.music,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.partyVibes')},
//       {id: '1', name: i18n.t('eventTheme.fusion')},
//       {id: '2', name: i18n.t('eventTheme.dJNight')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.trendyCasuals')},
//       {id: '1', name: i18n.t('dressCode.indoWestern')},
//       {id: '2', name: i18n.t('dressCode.funOutfits')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.neon')},
//       {id: '1', name: i18n.t('dressColor.metallic')},
//       {id: '2', name: i18n.t('dressColor.black')},
//       {id: '3', name: i18n.t('dressColor.white')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: '8',
//     name: i18n.t('eventsName.reception'),
//     tagline: i18n.t('eventTagline.reception'),
//     Icon: SVGS.reception,
//     theme: [
//       {id: '0', name: i18n.t('eventTheme.elegant')},
//       {id: '1', name: i18n.t('eventTheme.regal')},
//       {id: '2', name: i18n.t('eventTheme.modernLuxe')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressCode: [
//       {id: '0', name: i18n.t('dressCode.suitsGrowns')},
//       {id: '1', name: i18n.t('dressCode.indoWestern')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//     dressColor: [
//       {id: '0', name: i18n.t('dressColor.pastels')},
//       {id: '1', name: i18n.t('dressColor.silver')},
//       {id: '2', name: i18n.t('dressColor.champagne')},
//       {id: '3', name: i18n.t('dressColor.navyGrey')},
//       {id: 'custom', name: i18n.t('eventsName.custom')},
//     ],
//   },
//   {
//     id: 'custom',
//     name: i18n.t('eventsName.custom'),
//     tagline: '',
//     Icon: SVGS.custom,
//     theme: [{id: 'custom', name: i18n.t('eventsName.custom')}],
//     dressCode: [{id: 'custom', name: i18n.t('eventsName.custom')}],
//     dressColor: [{id: 'custom', name: i18n.t('eventsName.custom')}],
//   },
// ];




export const EVENT_NAME = [
  {
    id: '0',
    name: 'Roka',
    tagline: '',
    theme: [
      { id: '0', name: 'Traditional' },
      { id: '1', name: 'Floral' },
      { id: '2', name: 'Pastel' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Ethnic Wear' },
      { id: '1', name: 'Semi-Formal' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Pastel Shades (Peach, Mint, Lavender)' },
      { id: '1', name: 'Gold, Off-White' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '1',
    name: 'Engagement',
    tagline: '',
    theme: [
      { id: '0', name: 'Glam Night' },
      { id: '1', name: 'Royal' },
      { id: '2', name: 'Contemporary' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Indian Formal' },
      { id: '1', name: 'Indo-Western' },
      { id: '2', name: 'Suits/Dresses' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Silver' },
      { id: '1', name: 'Navy Blue' },
      { id: '2', name: 'Emerald' },
      { id: '3', name: 'Green' },
      { id: '4', name: 'Wine' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '2',
    name: 'Haldi',
    tagline: '',
    theme: [
      { id: '0', name: 'Vibrant' },
      { id: '1', name: 'Sunshine' },
      { id: '2', name: 'Floral' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Simple Ethnic' },
      { id: '1', name: 'Light Kurta/Saree' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Yellow' },
      { id: '1', name: 'Orange' },
      { id: '2', name: 'White' },
      { id: '3', name: 'Green' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '3',
    name: 'Mehndi',
    tagline: '',
    theme: [
      { id: '0', name: 'Color Splash' },
      { id: '1', name: 'Folk' },
      { id: '2', name: 'Garden' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Traditional' },
      { id: '1', name: 'Indo-Western' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Green' },
      { id: '1', name: 'Pink' },
      { id: '2', name: 'Yellow' },
      { id: '3', name: 'Turquoise' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '4',
    name: 'Sangeet',
    tagline: '',
    theme: [
      { id: '0', name: 'Glam & Glitz' },
      { id: '1', name: 'Bollywood' },
      { id: '2', name: 'Starry Night' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Sparkling Western (Tuxedos, Gowns)' },
      { id: '1', name: 'Indo Western (Sherwani, Lehenga)' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Gold, Black' },
      { id: '1', name: 'Maroon' },
      { id: '2', name: 'Metallic Shades' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '5',
    name: 'Cocktail',
    tagline: '',
    theme: [
      { id: '0', name: 'Chic' },
      { id: '1', name: 'Western' },
      { id: '2', name: 'Luxury Evening' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Sparkling Western (Tuxedos/Suits, Dresses/Gowns)' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Black' },
      { id: '1', name: 'Burgundy' },
      { id: '2', name: 'Navy, Silver' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '6',
    name: 'Wedding',
    tagline: '',
    theme: [
      { id: '0', name: 'Royal' },
      { id: '1', name: 'Heritage' },
      { id: '2', name: 'Traditional' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Ethnic Formals (Sherwani/Bandhgala, Lehenga/Saree)' },
      { id: '1', name: 'Indo-Western' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Red' },
      { id: '1', name: 'Gold' },
      { id: '2', name: 'Ivory' },
      { id: '3', name: 'Maroon' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '7',
    name: 'Music Bash',
    tagline: '',
    theme: [
      { id: '0', name: 'Party Vibes' },
      { id: '1', name: 'Fusion' },
      { id: '2', name: 'DJ Night' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Trendy Casuals' },
      { id: '1', name: 'Indo-Western' },
      { id: '2', name: 'Fun Outfits' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Neon' },
      { id: '1', name: 'Metallic' },
      { id: '2', name: 'Black' },
      { id: '3', name: 'White' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: '8',
    name: 'Reception',
    tagline: '',
    theme: [
      { id: '0', name: 'Elegant' },
      { id: '1', name: 'Regal' },
      { id: '2', name: 'Modern Luxury' },
      { id: 'custom', name: 'Custom' },
    ],
    dressCode: [
      { id: '0', name: 'Suits, Gowns/Sarees' },
      { id: '1', name: 'Indo-Western' },
      { id: 'custom', name: 'Custom' },
    ],
    dressColor: [
      { id: '0', name: 'Pastels' },
      { id: '1', name: 'Silver' },
      { id: '2', name: 'Champagne' },
      { id: '3', name: 'Navy, Grey' },
      { id: 'custom', name: 'Custom' },
    ],
  },
  {
    id: 'custom',
    name: 'Custom',
    tagline: '',
    theme: [{ id: 'custom', name: 'Custom' }],
    dressCode: [{ id: 'custom', name: 'Custom' }],
    dressColor: [{ id: 'custom', name: 'Custom' }],
  },
];
